import { AbstractConfigSource, ConfigClient, cfg } from './config.js';
class HttpConfigSource extends AbstractConfigSource {
    constructor(options) {
        super(options.name, options.stage);
        this.fetchRetry = true;
        this.headers = {};
        Object.assign(this, options);
        this.encrypted = false;
    }
    decrypt(data) {
        return data;
    }
    async fetchUrl() {
        try {
            const response = await fetch(this.url, {
                headers: this.headers,
                keepalive: false,
                method: 'GET',
                mode: 'cors',
                cache: 'reload',
            });
            const data = await response.json();
            let resHeaders = {};
            for (const [key, val] of response.headers.entries()) {
                resHeaders[key] = val;
            }
            return {
                data,
                status: response.status,
                headers: resHeaders,
            };
        }
        catch (err) {
            if (this.fetchRetry) {
                // retry once with cloudfront url
                this.fetchRetry = false;
                this.urlPrefix = this.backupUrlprefix;
                return await this.fetchUrl();
            }
            throw new Error('failed to fetch: ' + err);
        }
    }
    loadFromFile() {
        return {};
    }
}
;
class ConfigClientWeb extends ConfigClient {
    constructor(stage) {
        super(stage);
        this.addSource(new HttpConfigSource({ stage: this.stage, name: 'frontend', urlPrefix: `https://config.${this.domain}` }));
        this.promise = this.loadConfigs(true);
    }
    /** This is intentionally a no-op in the front-end library.
     *  The back-end library actually implements decryption.
     */
    decrypt(data) {
        return data;
    }
}
let config;
const defaultStage = 'prod';
export function stage(stage = defaultStage) {
    if (!cfg[stage]) {
        cfg[stage] = new ConfigClientWeb(stage);
    }
    return cfg[stage];
}
config = stage(defaultStage);
export const promise = config.promise;
//@ts-ignore
config.stage = stage;
export default config;
//# sourceMappingURL=web.mjs.map